import API from './Api'

const endpointBaseUrl = 'events';

class RenginiaiService {
    baseUrl() {
        return endpointBaseUrl;
    }

    getRenginiai() {
        return API.get(endpointBaseUrl);
    }

    getRenginiaiVaikams() {
        return API.get(endpointBaseUrl + '?forkids=true');
    }

    getRenginys(id) {
        return API.get(endpointBaseUrl + '/' + id);
    }
}

export default new RenginiaiService();